import {
  Checkbox,
  Form,
  Input,
  notification,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import { uniqueId } from "lodash";
import axios from "@lhd/libs/axios";
import { LIMIT_UPLOAD_20_ATTACHMENT, ONE_MB, SERVICES } from "@lhd/constants";
import {
  DeleteOutlined,
  LoadingOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import CustomImage from "@lhd/components/CustomImage";
import { Suspense, useEffect, useRef, useState } from "react";
import { RcFile, UploadFile } from "antd/lib/upload";
import IconDownload from "../IconDownload";
import { Styles } from "./style";
import React from "react";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import {
  checkIsImageByLink,
  checkIsVideoByLink,
  fileCanPreview,
  getNameFileByUrl,
} from "@lhd/features/Apps/utils";
import ModalVideo from "@lhd/features/Apps/components/ModalVideo";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";
import TextToolTip from "@lhd/components/TextToolTip";
import { useUploadStatus } from "@lhd/components/CloneApp/contexts/UploadStatusContext";
const ModalPreviewOffice = React.lazy(
  () => import("@lhd/components/Modal/ModalPreviewOffice"),
);

const HEIGHT_MEDIA = 150;
const WIDTH_MEDIA = "100%";
type FileCustom = UploadFile & {
  is_allow_download_attachment?: boolean;
  isUploading?: boolean;
};

interface IProps {
  namePath: string | string[];
  item: AppPartType;
  isDisabled: boolean;
  isHiddleLabel?: boolean;
  isAllowEditColumn?: boolean;
  listFileUploaded?: any;
  setListFileUploaded?: React.Dispatch<any>;
  listUpdateAllowDownload?: any;
  setListUpdateAllowDownload?: React.Dispatch<any>;
  setListFileRemove?: React.Dispatch<any>;
  listFileRemove?: any;
  nameField?: string;
  selector?: string;
  multiple?: boolean;
  isTable?: boolean;
  onUploadStatusChange?: (isUploading: boolean) => void;
  styleColor?: any;
  onDelete?: () => void;
  onChange?: () => void;
}

const Attachment = (props: IProps) => {
  const {
    namePath,
    item,
    isDisabled,
    isTable,
    multiple = false,
    onUploadStatusChange,
    styleColor,
    onDelete,
    onChange,
  } = props;
  const uploadStatus = useUploadStatus();
  const normFile = (e: any) => {
    return [];
  };

  const form = Form.useFormInstance();
  const fileTtmUploadeds = useRef<{ [key: string]: string }>({});
  const [openModal, setOpenModal] = useState(false);
  const [urlPreviewOffice, setUrlPreviewOffice] = useState<string>();
  const normalizeFileList = (value: unknown): UploadFile[] =>
    Array.isArray(value) ? (value as UploadFile[]) : [];

  useEffect(() => {
    return () => {
      Object.values(fileTtmUploadeds.current).forEach((blobUrl) =>
        URL.revokeObjectURL(blobUrl),
      );
    };
  }, []);

  const handleUploadFile = async (options: any) => {
    if (options?.file) {
      onUploadStatusChange?.(true);
      uploadStatus?.startUpload();
      const blobUrl = URL.createObjectURL(options.file);
      const key = options.file.uid;
      fileTtmUploadeds.current = {
        ...fileTtmUploadeds.current,
        [key]: blobUrl,
      };
    }
    const formData = new FormData();
    formData.append("file", options.file);

    try {
      const response = await axios.post(SERVICES.UPLOAD_ATTACHMENT, formData);
      if (namePath) {
        const oldValue = normalizeFileList(form.getFieldValue(namePath));
        const oldValueNew = oldValue.map((f: UploadFile) => {
          if (f.uid === options.file.uid) {
            return response.data;
          } else return f;
        });
        form.setFieldValue(namePath, oldValueNew);
      }
    } finally {
      onUploadStatusChange?.(false);
      uploadStatus?.finishUpload();
    }
  };

  const handlePaste = async (e: React.ClipboardEvent<HTMLInputElement>) => {
    if (isDisabled) return;

    const clipboardData = e.clipboardData;
    if (!clipboardData) return;

    const files: RcFile[] = [];
    for (let i = 0; i < clipboardData.items.length; i++) {
      const clipItem = clipboardData.items[i];
      if (clipItem.kind === "file") {
        const file = clipItem.getAsFile() as RcFile;
        if (file) files.push(file);
      }
    }

    if (files.length === 0) return;

    for (const file of files) {
      const isInvalid = handleValidateFile(file);
      if (isInvalid === Upload.LIST_IGNORE) continue;

      const fileWithUid = Object.assign(file, { uid: uniqueId("paste_") });

      //  (preview URL)
      const blobUrl = URL.createObjectURL(fileWithUid);
      fileTtmUploadeds.current[fileWithUid.uid] = blobUrl;

      // Update the form immediately (before the actual upload).
      const oldFiles = normalizeFileList(form.getFieldValue(namePath));
      form.setFieldValue(namePath, [...oldFiles, fileWithUid]);

      // Upload to  server
      try {
        onUploadStatusChange?.(true);
        uploadStatus?.startUpload();
        const formData = new FormData();
        formData.append("file", fileWithUid);

        const res = await axios.post(SERVICES.UPLOAD_ATTACHMENT, formData);
        const uploadedFile = res.data;

        // Update the form after the upload is completed.
        const currentFiles = normalizeFileList(form.getFieldValue(namePath));
        const updatedFiles = currentFiles.map((f: any) =>
          f.uid === fileWithUid.uid ? uploadedFile : f,
        );
        form.setFieldValue(namePath, updatedFiles);
      } catch (err) {
        notification.error({
          message: "ファイルのアップロードに失敗しました。",
        });
      } finally {
        onUploadStatusChange?.(false);
        uploadStatus?.finishUpload();
        onChange?.();
      }
    }
  };

  const handleValidateFile = (file: RcFile) => {
    if (file.size > LIMIT_UPLOAD_20_ATTACHMENT * ONE_MB) {
      notification.error({
        message: `ファイルは${LIMIT_UPLOAD_20_ATTACHMENT}MB以下である必要があります。`,
      });
      return Upload.LIST_IGNORE;
    }
  };

  const renderContent = (file: UploadFile, url: string) => {
    const extension = fileCanPreview(url);
    return checkIsVideoByLink(url) || checkIsImageByLink(url) ? (
      <div
        style={{
          display: "inline-block",
          width: WIDTH_MEDIA,
        }}
      >
        {checkIsImageByLink(url) ? (
          <CustomImage
            width={"100%"}
            height={"100%"}
            style={{
              maxHeight: HEIGHT_MEDIA,
            }}
            src={url}
          />
        ) : (
          <ModalVideo src={url} />
        )}
      </div>
    ) : (
      <TextToolTip
        onClick={() => {
          if (!extension) return;
          extension && setOpenModal(true);
          setUrlPreviewOffice(url);
        }}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          color: styleColor?.color || (extension ? "#1890ff" : "black"),
          cursor: extension ? "pointer " : "auto",
        }}
      >
        {file.name || getNameFileByUrl(url)}
      </TextToolTip>
    );
  };
  const formItemContent = (
    <Styles
      className={`${isTable ? "attachment-table" : "attachment"} ${
        isDisabled ? "disabled" : ""
      } `}
    >
      <Form.Item
        name={namePath}
        valuePropName="fileList"
        getValueFromEvent={normFile}
        noStyle
        rules={getRuleValidation(item)}
      >
        <Upload.Dragger
          multiple={multiple}
          fileList={normalizeFileList(form.getFieldValue(namePath))}
          customRequest={(options) => handleUploadFile(options)}
          beforeUpload={handleValidateFile}
          accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.zip"
          progress={{
            strokeWidth: 5,
            showInfo: true,
          }}
          onChange={(e) =>
            form.setFieldValue(namePath, normalizeFileList(e.fileList))
          }
          disabled={isDisabled}
          itemRender={(_, file, files: FileCustom[], action) => {
            const fileAs = file as FileCustom;
            const url = fileAs.url;
            const isUploading = !url;
            return (
              <div
                className="item-list-file"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "3px 2px",
                  background: styleColor?.background || "#fff",
                  ...styleColor,
                }}
              >
                <div className="item-list-file-content">
                  {isUploading && (
                    <div
                      style={{
                        background: "rgb(0, 0, 0, 0.5)",
                        position: "absolute",
                        top: 0,
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 10,
                      }}
                    >
                      <Spin
                        style={{
                          color: "#fff",
                        }}
                        indicator={<LoadingOutlined spin />}
                        size="small"
                      />
                    </div>
                  )}
                  {renderContent(file, url || "")}
                </div>
                <div
                  className="actions_file"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "4px",
                  }}
                >
                  <Tooltip title="ダウンロード可能を選択">
                    <Checkbox
                      // disabled={
                      //   (!isNil(fileAs.id)
                      //     ? auth?.id != fileAs.user_id
                      //     : false) || isDisabled
                      // }
                      defaultChecked={!!fileAs.is_allow_download_attachment}
                      onChange={(e) => {
                        const newList = files.map((f) => {
                          const cloneFile = { ...f } as FileCustom;
                          if (cloneFile.url === file.url) {
                            cloneFile.is_allow_download_attachment =
                              e.target.checked;
                          }
                          return cloneFile;
                        });
                        form.setFieldValue(namePath, newList);
                        onChange?.();
                        e.stopPropagation();
                      }}
                    />
                  </Tooltip>
                  <IconDownload
                    url={url || ""}
                    isUploading={isUploading}
                    isDisabled={!fileAs.is_allow_download_attachment}
                  />
                  <DeleteOutlined
                    style={{
                      opacity: isDisabled ? 0.5 : 1,
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (isDisabled) return;
                      action.remove();
                      onDelete?.();
                    }}
                  />
                </div>
              </div>
            );
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Input
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                if (typeof e.target.value === "string") {
                  e.stopPropagation();
                }
              }}
              value={""}
              onPaste={(e) => {
                handlePaste(e);
                e.stopPropagation();
              }}
            />
            <div
              className="icon_attachment"
              style={{
                width: 40,
                height: 40,
                fontSize: 30,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderLeft: "1px dashed #d9d9d9",
              }}
            >
              <PaperClipOutlined />
            </div>
          </div>
        </Upload.Dragger>
      </Form.Item>
      {openModal && (
        <Suspense fallback={<Spin />}>
          <ModalPreviewOffice
            modalProps={{
              destroyOnClose: true,
              open: openModal,
              onCancel: () => {
                setOpenModal(false);
              },
            }}
            uri={urlPreviewOffice}
          />
        </Suspense>
      )}
    </Styles>
  );

  return formItemContent;
};

export default Attachment;
